<template>
    <outboxCon :bg="bg">
        <div class="little-big">
            <app-title :main="main" :sub="sub"></app-title>
            <div class="compare-box">
                <div class="info-box fun-box">
                    <div class="info-li title">
                        <div>{{configList.first.name}}</div>
                    </div>
                    <div v-for="(item, index) in configList.first.content" :key="`live-fun${index}`" class="info-li">
                        <div>{{item}}</div>
                    </div>
                </div>
                <div class="info-box big-box">
                    <div class="info-li title">
                        <img class="icon-big" :src="configList.second.icon">
                        <div>{{configList.second.name}}</div>
                    </div>
                    <div class="info-li" v-for="(item, index) in configList.second.content" :key="`live-second${index}`">
                        <div v-if="item">{{item}}</div>
                        <img v-else class="icon-none" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/compare-none.png">
                    </div>
                </div>
                <div class="info-box little-box">
                    <div class="info-li title">
                        <img class="icon-good" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/little-good.png">
                        <img class="icon-little" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/compare-little.png">
                        <div>{{configList.third.name}}</div>
                    </div>
                    <div class="info-li" v-for="(item, index) in configList.third.content" :key="`live-third${index}`">
                        <div class="little-info">
                            <p class="little-mes" v-html="item"></p>
                            <img class="icon-rise" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/little-rise.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
export default {
  props: {
    bg: {
      type: String,
      default: ''
    },
    main: {
      type: String,
      default: ''
    },
    sub: {
      type: String,
      default: ''
    },
    isLive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      liveConfig: {
        first: {
          icon: '',
          name: '功能对比',
          content: ['师资设备', '主讲背景', '主讲稳定性', '教研能力', '课后服务', '课堂互动', '办学成本']
        },
        second: {
          icon: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/icon-teacher.png',
          name: '传统面授',
          content: ['本地老师授课', '普通本科', '不稳定、易流失', '参差不齐', '难兼顾', '形式单一、传统', '主讲老师高分成']
        },
        third: {
          icon: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/compare-big.png',
          name: '双师课堂',
          content: ['北京老师主讲、本地老师辅导', '清北、985背景，多年授课经验', '稳定性强', '标准化', '辅导老师专职负责', '趣味多样', '固定课时费']
        }
      },
      littleConfig: {
        first: {
          icon: '',
          name: '功能对比',
          content: ['主讲老师', '辅导老师', '课后服务']
        },
        second: {
          icon: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/compare-big.png',
          name: '大班网课',
          content: ['纯输出内容，与学生无交流', '', '难兼容']
        },
        third: {
          icon: '',
          name: '双师小组课',
          content: ['至少10分钟1次课程相关<span style="color: #FB5A4B;">内容互动</span>', '<span style="color: #FB5A4B;">在线伴学</span>，关注每个学生学习情况', '辅导老师根据学生课堂学习数据，课后进行<span style="color: #FB5A4B;">定制化辅导</span>']
        }
      }
    }
  },
  computed: {
    configList () {
      return this.isLive ? this.liveConfig : this.littleConfig
    }
  }
}
</script>
<style lang="scss" scoped>
    .little-big{
        padding: 50px 160px 60px;
        width: $main-width;
        margin: 0 auto;
        .strong{
            color: #FB5A4B;
        }
        .compare-box{
            margin-top: 56px;
            display: flex;
            justify-content: center;
            align-items: center;
            .info-box{
                padding-bottom: 16px;
                background:rgba(255,255,255,1);
                border:1px solid rgba(238,238,238,1);
                .info-li{
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 58px;
                    font-size:14px;
                    font-family:PingFangSC-Regular;
                    .icon-big{
                        width: 21px;
                        height: 22px;
                        margin-right: 8px;
                    }
                    .icon-little{
                        width: 32px;
                        height: 32px;
                        margin-right: 8px;
                    }
                    .icon-none{
                        width: 17px;
                        height: 29px;
                    }
                    &:nth-child(even){
                        background: #F8F9FD;
                    }
                    &.title{
                        height: 118px;
                        font-size:22px;
                        font-family:PingFangSC-Medium;
                        line-height:30px;
                    }
                }
                &.fun-box{
                    border-radius:10px 0px 0px 10px;
                    width: 230px;
                }
                &.big-box{
                    width: 360px;
                    margin-left: -1px;
                    .info-li{
                        color: #999999;
                        &.title{
                            color: $base-font-color;
                        }
                    }
                }
                &.little-box{
                    box-shadow:0px 6px 18px 0px rgba(147,147,147,0.14);
                    border-radius:10px;
                    border:1px solid rgba(131,190,255,1);
                    width: 381px;
                    margin-left: -6px;
                    position: relative;
                    top: -1px;
                    padding-bottom: 20px;
                    .info-li{
                        color: #999999;
                        .little-info{
                            width: 100%;
                            display: flex;
                            justify-content: flex-end;
                            align-items: center;
                            padding-right: 10px;
                            .little-mes{
                                flex: 1;
                                text-align: center;
                                color: #122D49;
                                .strong{
                                    color: #FB5A4B;
                                }
                            }
                            .icon-rise{
                                width: 18px;
                                height: 17px;
                                float: right;
                            }
                        }
                        &.title{
                            color: $base-font-color;
                            position: relative;
                            height:125px;
                            background:linear-gradient(123deg,rgba(109,178,255,1) 0%,rgba(79,137,255,1) 100%);
                            box-shadow:0px 6px 18px 0px rgba(147,147,147,0.14);
                            overflow: hidden;
                            border-radius:9px 9px 0px 0px;
                            color: #ffffff;
                            .icon-good{
                                position: absolute;
                                top: 0px;
                                left: 0px;
                                width: 76px;
                                height: 76px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
